import "react-toastify/dist/ReactToastify.css";

import { toast } from "react-toastify";
const showToastMessage = (
  messageType: boolean,
  message: string,
  toastID?: string,
) => {
  messageType
    ? toast.success(message || "Success!", {
        autoClose: 2000,
        position: toast.POSITION.TOP_RIGHT,
        toastId: toastID,
      })
    : toast.error(message, {
        autoClose: 2000,
        position: toast.POSITION.TOP_RIGHT,
      });
};
export default showToastMessage;
